module.exports = __webpack_public_path__ + "img/egg-2.437f20f9.svg";